import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicleAllPlates } from '../../../../store/slices/vehicle';

/**
 * Hook personalizado para buscar placas de veículos.
 *
 * @returns {{
 *   loading: boolean,
 *   plates: string[]
 * }}
 */
export const useFetchPlates = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const vehiclePlates = useSelector((state) => state.vehicle.vehicleAllPlates);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                if (vehiclePlates.length === 0) {
                    await dispatch(fetchVehicleAllPlates());
                }
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line
    }, [dispatch]);

    return { loading, plates: vehiclePlates };
};
